import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Users from './pages/Users';
import Clients from './pages/Clients';
import Activities from './pages/Activities';
import Logs from './pages/Logs';
import Attachments from './pages/Attachments';
import UserDashboard from './pages/UserDashboard';
import Backups from './pages/Backups';
import './App.css';

const PrivateRoute = ({ children, adminOnly = false, userOnly = false }) => {
  const { user, isAdmin } = useAuth();
  if (!user) return <Navigate to="/login" />;
  if (adminOnly && !isAdmin) return <Navigate to="/dashboard" />;
  if (userOnly && isAdmin) return <Navigate to="/users" />;
  return children;
};

const Layout = ({ children }) => (
  <div className="app-layout">
    <Sidebar />
    <main className="main-content">{children}</main>
  </div>
);

const AppRoutes = () => {
  const { user, isAdmin } = useAuth();

  const getDefaultRoute = () => {
    if (!user) return '/login';
    return isAdmin ? '/users' : '/dashboard';
  };

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={getDefaultRoute()} /> : <Login />} />
      <Route path="/dashboard" element={<PrivateRoute userOnly><Layout><UserDashboard /></Layout></PrivateRoute>} />
      <Route path="/users" element={<PrivateRoute adminOnly><Layout><Users /></Layout></PrivateRoute>} />
      <Route path="/clients" element={<PrivateRoute adminOnly><Layout><Clients /></Layout></PrivateRoute>} />
      <Route path="/activities" element={<PrivateRoute adminOnly><Layout><Activities /></Layout></PrivateRoute>} />
      <Route path="/attachments" element={<PrivateRoute adminOnly><Layout><Attachments /></Layout></PrivateRoute>} />
      <Route path="/logs" element={<PrivateRoute adminOnly><Layout><Logs /></Layout></PrivateRoute>} />
      <Route path="/backups" element={<PrivateRoute adminOnly><Layout><Backups /></Layout></PrivateRoute>} />
      <Route path="*" element={<Navigate to={getDefaultRoute()} />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
